export function arraysMatch<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false
  return arr1.sort().join(',') === arr2.sort().join(',')
}
